<template>
  <v-row fill-height fluid>

    <div class="text-center" style="width: 100%;">
      <h2 class="font-weight-regular mb-4">
        {{ $t('components.jobhistory_measure.title') }}
      </h2>
    </div>

    <!--    EMPTY JOB HISTORY-->
    <template v-if="step==='start'">
      <div class="text-center" style="width: 100%;">

        <p class="mb-0">{{ $t('components.jobhistory_measure.instruction') }}</p>
        <p class="mt-0">{{ $t('components.jobhistory_measure.start') }}</p>

        <v-btn color="secondary mb-5" fab @click="addJobHistory(true)">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </div>
    </template>


    <!--    ALREADY HAS JOB HISTORY-->
    <template v-else-if="step==='jobhistory'">
      <div class="text-center" style="width: 100%;">
        <p>{{ $t('components.jobhistory_measure.instruction') }}</p>
      </div>
      <!--      <transition name="slide-y-transition">-->
      <v-container v-if="jobHistories && jobHistories.length > 0" fluid>
        <transition-group name="flip-list">
          <v-row v-for="(job, idx) in jobHistories" :key="'jobhistory_'+job.id">
            <v-col v-if="!$vuetify.breakpoint.smAndDown" md="1" lg="2"></v-col>
            <v-col cols="10" md="9" lg="8">
              <JobHistoryStrip v-model="jobHistories[idx]"
                               :years="years"
                               @delete="removeJobHistory(idx)"
                               @fromyearChanged="reorderStrips()"
              ></JobHistoryStrip>
            </v-col>
            <v-col cols="2" v-if="idx === 0">
              <v-btn medium fab class="mt-3" color="secondary" @click="addJobHistory()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </transition-group>
      </v-container>
      <!--        </transition>-->
    </template>

<!--    <div class="text-center" style="width: 100%;" v-if="error">-->
<!--    <p class="error&#45;&#45;text text&#45;&#45;lighten-2">{{$t('components.jobhistory_measure.errors.one_required')}}</p>-->
<!--    </div>-->

    <div class="text-center mb-5" :style="step==='start' ? 'margin-top: 50px' : 'inherit'" style="width: 100%" v-if="step==='jobhistory' || step ==='start'">
      <template v-if="step==='start'">{{$t('general.or')}} <br><br></template> <v-btn color="secondary" @click="confirm()">{{$t('general.continue')}}</v-btn>
    </div>

    <!--    BEFORE CONTINUE DIALOG-->
    <v-dialog v-model="confirmDialog" max-width="290">
      <v-card light>
        <v-card-title class="headline">{{$t('components.jobhistory_measure.complete_dialog.title')}}</v-card-title>
        <v-card-text>
          {{$t('components.jobhistory_measure.complete_dialog.body', {number:$t_num(numValidjobHistories || 0)})}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" text @click="addJobHistory(); confirmDialog=false">{{$t('components.jobhistory_measure.complete_dialog.add_more')}}</v-btn>
          <v-btn color="primary" text @click="next()">{{$t('general.continue')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import removeautocompletes from "../../../../mixins/removeautocompletes";
  import JobHistoryStrip from "./JobHistoryStrip";

  export default {
    name: "JobHistoryMeasure",
    mixins: [removeautocompletes],
    components: {JobHistoryStrip},
    data() {
      return {
        step: 'start',
        loading: '',
        years: [],
        jobHistories: [],
        jobHistoryTemplate: {
          employer: '',
          jobtitle: '',
          fromyear: '',
          toyear: '',
          id:'',
        },
        ready: false,
        possibleJobTitles: [],
        possibleCompanies: [],
        error:false,
        confirmDialog:false,
        numValidjobHistories:0,
      }
    },
    watch:{
      'jobHistories' : function(){
        this.validateJobHistoryMeasure();
      }
    },
    methods: {
      validateJobHistoryMeasure(strict = false){

        if(!strict){
          this.error= false;
          return;
        }

        let isValid = false;

        if(this.jobHistories.length < 1) return false;

        this.numValidjobHistories = 0;

        for(let i = 0; i < this.jobHistories.length; i++){
          const h = this.jobHistories[i];
          if(h.employer && h.jobtitle && h.fromyear && (!h.toyear || (h.toyear && h.toyear > h.fromyear))){
          // if(h.employer && h.jobtitle && h.fromyear){
            this.error = false;
            isValid = true;
            this.numValidjobHistories++;
            // break;
          }
        }

        this.error = !isValid;

        return !this.error;
      },
      confirm(){

        this.validateJobHistoryMeasure(true);

        // if(!this.validateJobHistoryMeasure(true))
        //   return;

        this.confirmDialog = true;
      },
      next() {
        this.confirmDialog = false;

        // if(!this.validateJobHistoryMeasure(true))
        //   return;

        this.$emit('complete');
      },
      initialize() {
        let state = this.$store.state;
        if (state.assessment == null || state.assessment.assessment == null || state.assessment.assessment.person == null) {
          //Todo error
          return;
        }

        this.jobHistories = this.$store.state.assessment.assessment.person.jobhistory;

        this.jobHistories.sort((a, b) => a.fromyear - b.fromyear).map((item) => {
          item.id = Math.random().toString(36).substr(2, 5)
        });

        let year = new Date().getFullYear();
        let to = 1950;
        while (to <= year) {
          this.years.push(year--);
        }

        if(this.jobHistories != null && this.jobHistories.length > 0)
          this.step = 'jobhistory';

        setTimeout(() => {
          this.ready = true;
        }, 1000);

        this.getInitialJobhistoryEntities();

      },
      getInitialJobhistoryEntities() {
        this.$http.get('entitytypes/jobhistory/column/jobtitle/entities').then(
          (res) => {
            this.possibleJobTitles = res.data;
          },
          () => {
          });

        this.$http.get('entitytypes/jobhistory/column/company/entities').then(
          (res) => {
            this.possibleCompanies = res.data;
          },
          () => {
          });
      },
      addJobHistory(initial) {
        let jobHistoryTemplate = JSON.parse(JSON.stringify(this.jobHistoryTemplate));

        //give it a random key so that the sorting animation works
        jobHistoryTemplate.id = Math.random().toString(36).substr(2, 5);
        this.jobHistories.push(JSON.parse(JSON.stringify(jobHistoryTemplate)));

        if (initial || this.jobHistories.length > 0) {
          this.step = 'jobhistory';
        }
      },
      removeJobHistory(index) {
        if (this.jobHistories.length < 1) return;

        if (this.jobHistories[index].jobhistoryid != null) {

          this.$http.delete('person/jobhistories/' + this.jobHistories[index].jobhistoryid).then(
            () => {
              //TODO snackbar here
              //console.log(this.$t('components.jobhistory_measure.delete_success_snackbar'));
            }
          );
        }
        this.$delete(this.jobHistories, index, 1);

        if (this.jobHistories.length < 1) this.step='start';
      },
      reorderStrips() {
        if (!this.ready) return;

        this.jobHistories.sort((a, b) => a.fromyear - b.fromyear);
      },
    },
    mounted() {
      this.initialize();
    }
  }
</script>

<style lang="scss">
  .flip-list-move {
    transition: transform 0.8s;
  }
</style>
